/*
 * 1DS JS SDK ID Sync plugin, 3.1.3
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
import { __extendsFn as __extends } from "@microsoft/applicationinsights-shims";
/**
* WebAnalyticsPlugin.ts
* @author Ram Thiru (ramthi) and Hector Hernandez (hectorh)
* @copyright Microsoft 2018
* File containing the interfaces for WebAnalytics SDK.
*/
import { BaseTelemetryPlugin, } from "@microsoft/1ds-core-js";
import Ix from "./Ix";
var IdSyncPlugin = /** @class */ (function (_super) {
    __extends(IdSyncPlugin, _super);
    function IdSyncPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.identifier = "IdSyncPlugin";
        _this.version = '3.1.3';
        return _this;
    }
    /**
     * Starts the WebAnalytics plugin
     * @param config The core configuration.
    */
    IdSyncPlugin.prototype.initialize = function (coreConfig, core, extensions) {
        var _this = this;
        // Make sure we have a config definition for this identifier
        var identifier = this.identifier;
        var extConfig = coreConfig.extensionConfig[identifier] || {};
        coreConfig.extensionConfig[identifier] = extConfig;
        // Iterate other loaded extensions
        var postChannel = null;
        // Check in channels
        if (coreConfig.channels) {
            for (var i = 0; i < coreConfig.channels.length; i++) {
                if (coreConfig.channels[i]) {
                    for (var j = 0; j < coreConfig.channels[i].length; j++) {
                        var channel = coreConfig.channels[i][j];
                        if (channel.identifier === "PostChannel") {
                            postChannel = coreConfig.channels[i][j];
                            break;
                        }
                    }
                }
            }
        }
        // Check in extensions
        if (!postChannel) {
            for (var i = 0; i < extensions.length; i++) {
                if ((extensions[i]).identifier === "PostChannel") {
                    postChannel = extensions[i];
                    break;
                }
            }
        }
        if (postChannel) {
            this._ix = new Ix(extConfig, core);
            postChannel.addResponseHandler(function (response) { _this._ix.idSync(response); });
        }
    };
    /**
     * Process a given event.
     * Hydrate with appropriate PartB and PartC data
     * @param evt - The event to be hydrated.
     * @param itemCtx - This is the context for the current request, ITelemetryPlugin instances
     * can optionally use this to access the current core instance or define / pass additional information
     * to later plugins (vs appending items to the telemetry item)
     */
    IdSyncPlugin.prototype.processTelemetry = function (evt, itemCtx) {
        this.processNext(evt, itemCtx);
    };
    return IdSyncPlugin;
}(BaseTelemetryPlugin));
export { IdSyncPlugin };
//# sourceMappingURL=IdSyncPlugin.js.map